module.exports = __webpack_public_path__ + "static/media/4ODA9.dd54f819.jpg";